import { useMatches } from "react-router-dom";

export default function useParentLoaderData(level = 1) {
  const matches = useMatches();
  const parentRoute = matches[matches.length - (level + 1)];
  return parentRoute.data;
}
